import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Generic KPI card row (same look as ProspectGeneralStats) with an optional
 * green/red delta badge (vs N-1 or vs objective).
 * cards: [{ label, value, bgColor, suffix, deltas: [{ label, value }] }]
 * featuredFirst: the first card (the Total) spans the height of the grid on
 * the left; the others each take one line / one column beside it.
 */
const StatCards = ({ cards = [], featuredFirst = false }) => {
  const { t } = useTranslation("common");

  const renderCard = ({ label, value, bgColor, suffix, deltas }, featured) => (
    <div
      className={`p-3 px-4 br20 h-100 d-flex flex-column ${
        featured ? "justify-content-center" : "justi"
      }`}
      style={{ backgroundColor: bgColor ?? "#577b87" }}
    >
      <span
        className={`d-block text-white sBold mb-1 ${featured ? "f18" : "f16"}`}
      >
        {t(`${label}`)}
      </span>
      <span
        className={`d-block text-white text-nowrap bold ${
          featured ? "f30" : "f22"
        }`}
      >
        {value ?? 0}
        {suffix ?? ""}
      </span>
      {deltas?.map(
        (delta) =>
          delta?.value !== null &&
          delta?.value !== undefined && (
            <span
              key={delta.label}
              className={`d-inline-block mt-2 me-2 px-2 py-1 br5 f12 sBold text-white ${
                delta.value >= 0 ? "bg-green-600" : "bg-red-600"
              }`}
            >
              {delta.value >= 0 ? "+" : ""}
              {delta.value}% {t(`${delta.label}`)}
            </span>
          ),
      )}
    </div>
  );

  if (featuredFirst && cards.length > 1) {
    const [first, ...rest] = cards;
    return (
      <div className="row g-3 pt-2 pb-2">
        <div className="col-12 col-md-3">{renderCard(first, true)}</div>
        <div className="col-12 col-md-9">
          <div className="row g-3 h-100">
            {rest.map((card) => (
              <div className="col-6 col-md-4" key={card.label}>
                {renderCard(card)}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row g-3 pt-2 pb-2">
      {cards.map((card) => (
        <div className="col-3" key={card.label}>
          {renderCard(card)}
        </div>
      ))}
    </div>
  );
};

/** % evolution between a current and a previous value (1 decimal), or null. */
export const deltaPct = (current, previous) => {
  if (!previous) return null;
  return Math.round(((current - previous) / previous) * 1000) / 10;
};

export default StatCards;
